import MxTypography from "../MxTypography";

export interface IMxModalTitleProps {
  title: string;
}

function MxModalTitle(props: IMxModalTitleProps) {
  return (
    <MxTypography variant="subtitle2" color="primary.main" textAlign={"left"}>
      {props.title}
    </MxTypography>
  );
}

export default MxModalTitle;
